import { supabase } from "@/integrations/supabase/client";

/**
 * Global click listener that logs anonymous lead events when visitors click
 * the "Book a Call" (Cal.com) or "Call Us Direct" (tel:) buttons.
 *
 * We don't have an email at this point, so we store a placeholder email of
 * the form `anon+<source>+<timestamp>@tabletalktv.local`. The admin dashboard
 * shows the source + date so the team can see where engagement came from.
 */
export function initLeadTracking() {
  if (typeof window === "undefined") return;
  if ((window as unknown as { __leadTrackingInit?: boolean }).__leadTrackingInit) return;
  (window as unknown as { __leadTrackingInit?: boolean }).__leadTrackingInit = true;

  document.addEventListener("click", (e) => {
    const target = e.target as HTMLElement | null;
    if (!target) return;
    const anchor = target.closest("a") as HTMLAnchorElement | null;
    if (!anchor) return;

    const href = anchor.getAttribute("href") ?? "";
    let source: string | null = null;

    if (href.startsWith("tel:")) {
      source = "direct_call";
    } else if (href.includes("cal.com")) {
      source = "booking_call";
    }

    if (!source) return;

    const placeholderEmail = `anon+${source}+${Date.now()}@tabletalktv.local`;

    // Fire and forget - don't block navigation
    void supabase
      .from("leads")
      .insert({ email: placeholderEmail, marketing_opt_in: false, source });
  });
}
